var map = {
	"./account.svg": "f6a7",
	"./accounts.svg": "5d35",
	"./douyin-new.svg": "4cde",
	"./feedback.svg": "4179",
	"./feedbacks.svg": "b7d6",
	"./gift-new.svg": "f20d",
	"./gold_charter.svg": "96ba",
	"./help.svg": "f59b",
	"./helps.svg": "61b4",
	"./jingxuan.svg": "844a",
	"./lack-song.svg": "39c9",
	"./like-song.svg": "9cef",
	"./maiba-new.svg": "1dd7",
	"./mine-vip.svg": "9784",
	"./more.svg": "6f5f",
	"./my-music.svg": "228b",
	"./my-musics.svg": "6942",
	"./new-song.svg": "d24d",
	"./newMore.svg": "0d6f",
	"./record.svg": "3464",
	"./records.svg": "1c49",
	"./send-bless.svg": "38ea",
	"./send-photo.svg": "cf55",
	"./shu.svg": "c141",
	"./song-likes.svg": "7a87",
	"./zhiding.svg": "2ef1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5320";